<template>
    <div>
        <rkm-table
            :items="dados"
            :fields="fields.tables.tipo"
            :filter="filter"
            sort-by="nomeFantasia"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter && !model.tipoUnidade"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(urgencia)="{ item }">
                {{ item.urgencia ? 'Sim' : 'Não' }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'nomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'urgencia', label: 'Urgência/Emergência', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
        dados(){

            return this.data.model.unidadesSolicitantes
        },
    },
    data: () => ({
        items: [],
        model:{
            tipoUnidade: null,
        },
        filter: null,
        enums: {
            tipoUnidade
        },
    }),
    methods: {
        handleDestroy(item) {

            const hasItem = this.data.model.unidades.some(unidade =>
                unidade.unidadeColetaSolicitante.some(coleta =>
                    coleta.unidadeSolicitanteInfraestruturaId === item.infraestruturaId
                )
            );

            if (hasItem) {

                this.showAlert(`A exclusão da unidade não é permitida, pois ela já está associada como unidade
                    solicitante em uma unidade de coleta.`, 'Atenção')
                return
            }

            const objIndex = this.data.model.unidadesSolicitantes.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.unidadesSolicitantes.splice(objIndex, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy)
        },
        handleClearFilter() {
            this.filter = null
            this.model.tipoUnidade = null
        },
        handleEditar(index, item) {

            let unidade = this.data.model.unidadesSolicitantes.find(u => u.id === item.id)

            this.$refs.Modal.open(index, unidade)
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>